import { getStatusColor, getStatusLabel } from "../../../../../../utils/inventory/transferStatusUtils";

const StatusBadge = ({ status }: { status: string }) => {
  return (
    <span
      className={`
        inline-flex items-center 
        px-3 py-1 rounded text-xs font-semibold
        ${getStatusColor(status)}
      `}
    >
      {getStatusLabel(status)}
    </span>
  );
};

export default StatusBadge;
